/* ==========================================================================
   Dropdayz — de hoofdfoto op de productpagina op één schaal. 27 augustus 2026.

   WAAROM. assets/ddz-kaart-schaal.js normaliseert alleen .ddz-card-img in een
   .ddz-tegel: de kaarten in rasters en 'Recent bekeken'. De grote foto op de
   productpagina heeft een andere klasse en viel er dus buiten.

   GEMETEN OVER TWAALF SNEAKERS, in het kader van 584x439 op de productpagina:
   de schoen kwam in beeld tussen 71% en 96% van de kaderbreedte. 25
   procentpunt verschil. Birkenstock Naples 412 px breed, Saucony Black 558 px.
   Klik je van het ene product naar het andere, dan springt de schoen
   zichtbaar in grootte. Op de kaarten gebeurt dat niet; daar staat het vast.

   ------------------------------------------------------------------
   DE VALKUIL DIE DIT MOEILIJK MAAKT — LEES DIT VOOR JE IETS VERANDERT

   De zoomfunctie legt een TWEEDE afbeelding over de eerste: .zoomImg, de foto
   op volle resolutie (1250x891), als BROER van de gewone foto in
   .product-single__media. Die broer wordt door de zoomplugin bestuurd met
   left/top in pixels, opnieuw gezet bij elke muisbeweging. Nagemeten: er staat
   transform:none op, opacity gaat van 0 naar 1 bij hover.

   Zou je alleen de gewone foto schalen, dan blijft de zoomlaag ongeschaald en
   verspringt het beeld bij hover zichtbaar naar een andere uitsnede. Dat is
   exact de "spookschoen" van taak 71, die we niet terug willen.

   DAAROM: er komt EEN omhulsel om ALLEBEI de afbeeldingen heen, en DAT wordt
   geschaald. Basis en zoomlaag schuiven dus altijd samen. Het omhulsel staat
   op position:absolute met inset:0 — precies de maat van de container die het
   als offsetParent vervangt — zodat de left/top-berekening van de plugin
   blijft kloppen. Nagetest met een echte hover: de zoomlaag erft
   matrix(1.284, ...) en blijft uitgelijnd.

   Maak hier nooit twee losse transforms van. Dan lopen ze uit elkaar.

   BIJWERKING, bewust geaccepteerd: de zoom vergroot nu k keer sterker dan
   eerst (2,1x werd ongeveer 2,7x). Voor het bekijken van stiksels en labels
   is dat eerder winst dan verlies. Wil je terug naar de oude vergroting, dan
   moet de zoomplugin zelf een kleinere bronafbeelding krijgen — niet hier.
   ------------------------------------------------------------------

   GEEN GEVAAR VOOR AFSNIJDEN. k = min((kader*0,90)/contourbreedte,
   (kader*0,86)/contourhoogte), dus na schalen is de contour per definitie
   hoogstens 90% breed en 86% hoog. K_MIN grijpt alleen in onder 0,85 en dat
   zou een contour van meer dan 106% vragen — bestaat niet.

   VEILIG BIJ MISLUKKING. Lukt het meten niet (CORS, te klein, of de foto vult
   het kader al), dan gebeurt er niets en staat de foto zoals hij altijd stond.

   UITZETTEN. Zet AAN hieronder op false, of haal de scriptregel uit
   snippets/ddz-footer-info.liquid. Er blijft niets van achter.
   ========================================================================== */
(function () {
  'use strict';

  var AAN = true;
  if (!AAN) { return; }
  if (!document.body || document.body.className.indexOf('template-product') === -1) { return; }

  /* Doelvak. Bewust groter dan de 74% van de kaart: op de productpagina hoort
     het product groot in beeld. Gemiddeld stond hij al op 87%, dus vrijwel
     niets wordt kleiner — alles wordt gelijk. */
  var DOEL_B = 0.90;
  var DOEL_H = 0.86;
  var K_MIN = 0.85;
  var K_MAX = 1.55;
  var WIT = 246;
  var ALFA = 8;
  var MEET_BREED = 140;
  var SLEUTEL = 'ddz-pdpfit-v1';

  var kast = {};
  try { kast = JSON.parse(localStorage.getItem(SLEUTEL) || '{}') || {}; } catch (e) { kast = {}; }

  function bewaar() {
    try {
      if (Object.keys(kast).length > 400) { kast = {}; }
      localStorage.setItem(SLEUTEL, JSON.stringify(kast));
    } catch (e) { /* vol of geblokkeerd: volgende keer opnieuw meten */ }
  }

  function sleutelVan(src) {
    if (!src) { return ''; }
    return src.split('?')[0].replace(/_(\d+)x(\.[a-z]+)$/i, '$2');
  }

  /* Contour van het product als fracties van het bestand. Bijna-witte pixels
     tellen niet mee, dus dit werkt op vrijstaande PNG's en op foto's die nog
     op wit staan. */
  function meet(afb) {
    var W = afb.naturalWidth, H = afb.naturalHeight;
    if (!W || !H) { return null; }
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d');
    x.drawImage(afb, 0, 0);
    var d;
    try { d = x.getImageData(0, 0, W, H).data; } catch (e) { return null; }

    var x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (var yy = 0; yy < H; yy++) {
      for (var xx = 0; xx < W; xx++) {
        var o = (yy * W + xx) * 4;
        if (d[o + 3] < ALFA) { continue; }
        if (d[o] >= WIT && d[o + 1] >= WIT && d[o + 2] >= WIT) { continue; }
        if (xx < x0) { x0 = xx; }
        if (xx > x1) { x1 = xx; }
        if (yy < y0) { y0 = yy; }
        if (yy > y1) { y1 = yy; }
      }
    }
    if (x1 < 0) { return null; }

    var bw = (x1 - x0 + 1) / W, bh = (y1 - y0 + 1) / H;
    if (bw * bh > 0.94 || bw * bh < 0.02) { return null; }
    return [+(x0 / W).toFixed(4), +(y0 / H).toFixed(4), +bw.toFixed(4), +bh.toFixed(4)];
  }

  function hoofdfoto() {
    var alle = document.querySelectorAll('#shopify-section-product-template img.product-featured-media'); for (var i = 0; i < alle.length; i++) { if (alle[i].offsetWidth) { return alle[i]; } } /* 9 sep 2026: de zichtbare foto, niet altijd de eerste */ return alle[0]
        || document.querySelector('#shopify-section-product-template img.product-featured');
  }

  function omhulsel(container) {
    var kinderen = container.children, w = null;
    for (var i = 0; i < kinderen.length; i++) {
      if (String(kinderen[i].className).indexOf('ddz-pdp-fitwrap') >= 0) { w = kinderen[i]; break; }
    }
    if (w) { return w; }
    w = document.createElement('div');
    w.className = 'ddz-pdp-fitwrap';
    w.style.cssText = 'position:absolute;left:0;top:0;right:0;bottom:0;' +
                      'transform-origin:50% 50%;';
    container.insertBefore(w, container.firstChild);
    return w;
  }

  /* Alles wat een afbeelding is naar binnen halen, ook een zoomlaag die de
     plugin pas bij de eerste hover aanmaakt. */
  function haalBinnen(container, w) {
    var kinderen = container.children;
    kinderen = Array.prototype.slice.call(kinderen); for (var i = 0; i < kinderen.length; i++) { /* 9 sep 2026: documentvolgorde, niet omgekeerd */
      var el = kinderen[i];
      if (el === w) { continue; }
      if (el.tagName === 'IMG' || String(el.className).indexOf('zoomImg') >= 0) {
        w.appendChild(el); var zl = w.querySelector('.zoomImg'); if (zl && zl !== el) { w.appendChild(zl); } /* zoomlaag altijd bovenop */
      }
    }
  }

  function pas(afb, f) {
    var container = afb.parentElement;
    if (!container || String(container.className).indexOf('ddz-pdp-fitwrap') >= 0) {
      container = container ? container.parentElement : null;
    }
    if (!container) { return; }

    var w = omhulsel(container);
    haalBinnen(container, w);

    var tw = container.clientWidth, th = container.clientHeight;
    var vw = afb.offsetWidth, vh = afb.offsetHeight;
    if (!tw || !th || !vw || !vh) { return; }

    /* hoe groot staat de foto echt in beeld, object-fit meegerekend */
    var ir = afb.naturalWidth / afb.naturalHeight;
    var rw, rh;
    if (vw / vh > ir) { rh = vh; rw = vh * ir; } else { rw = vw; rh = vw / ir; }

    var bw = f[2] * rw, bh = f[3] * rh;
    if (bw <= 0 || bh <= 0) { return; }

    var k = Math.min((tw * DOEL_B) / bw, (th * DOEL_H) / bh);
    if (k < K_MIN) { k = K_MIN; }
    if (k > K_MAX) { k = K_MAX; }

    var ox = ((f[0] + f[2] / 2) - 0.5) * rw;
    var oy = ((f[1] + f[3] / 2) - 0.5) * rh;

    w.style.transform = 'scale(' + k.toFixed(4) + ') translate(' +
      (-ox).toFixed(2) + 'px,' + (-oy).toFixed(2) + 'px)';
    w.setAttribute('data-ddz-k', k.toFixed(3));
  }

  var bezig = {};

  function behandel() {
    var afb = hoofdfoto();
    if (!afb || !afb.naturalWidth) { return; }
    var src = afb.currentSrc || afb.src;
    if (!src || src.indexOf('data:') === 0) { return; }
    var s = sleutelVan(src);
    if (!s) { return; }

    if (kast[s] === 0) { return; }
    if (kast[s]) { pas(afb, kast[s]); return; }
    if (bezig[s]) { return; }
    bezig[s] = 1;

    var proef = new Image();
    proef.crossOrigin = 'anonymous';
    proef.onload = function () {
      var f = meet(proef);
      kast[s] = f || 0;
      bewaar();
      if (f) { pas(afb, f); }
    };
    proef.onerror = function () { };
    proef.src = src.split('?')[0] + '?width=' + MEET_BREED;
  }

  function start() {
    behandel();
    setTimeout(behandel, 700);
    setTimeout(behandel, 1800);

    var eerste = hoofdfoto();
    var container = eerste ? eerste.parentElement : null;
    if (container && 'MutationObserver' in window) {
      var wacht;
      new MutationObserver(function () {
        clearTimeout(wacht);
        wacht = setTimeout(function () {
          var afb = hoofdfoto();
          if (!afb) { return; }
          var c = afb.parentElement;
          if (c && String(c.className).indexOf('ddz-pdp-fitwrap') >= 0) {
            haalBinnen(c.parentElement, c);
          }
          behandel();
        }, 60);
      }).observe(document.getElementById('shopify-section-product-template') || container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src'] }); /* 9 sep 2026: hele sectie, ook thumbnail-wissel */
    }

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(behandel, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
